import { render, staticRenderFns } from "./employedetails.vue?vue&type=template&id=55fdf379&scoped=true&"
import script from "./employedetails.vue?vue&type=script&lang=js&"
export * from "./employedetails.vue?vue&type=script&lang=js&"
import style0 from "./employedetails.vue?vue&type=style&index=0&id=55fdf379&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fdf379",
  null
  
)

export default component.exports